import ActionPlan from '@/domain/activity/entity/action-plan.entity';
import moment from 'moment';

export interface SkillOption {
  value: number;
  text: string;
  details: string;
}

export default class AssessmentItem {
  assessmentItemId: string;

  whatPTBR: string;

  whatEN: string;

  whatES: string;

  type: AssessmentItemSkillType;

  response: SkillOption;

  expected: SkillOption;

  fetched: boolean = false;

  pdiPlan: ActionPlan;

  planId: string;

  planState: string;

  keyAreaSkillId?: string;

  skillId: string;

  createdDate: string;

  isAdherent: boolean = false;

  notAnswered: boolean = false;

  constructor(obj: any = {}) {
    this.assessmentItemId = obj.assessmentItemId || '';
    this.whatPTBR = obj.whatPTBR || '';
    this.whatEN = obj.whatEN || '';
    this.whatES = obj.whatES || '';
    this.type = obj.type;
    this.response = obj.response || '';
    this.expected = obj.expected || '';
    this.planId = obj.planId || '';
    this.keyAreaSkillId = obj.keyAreaSkillId || '';
    this.pdiPlan = obj.pdiPlan ? obj.pdiPlan : new ActionPlan(
      {
        id: obj.planId ? obj.planId : '',
        what: this.whatPTBR,
        planType: obj.type ? obj.type.value : '',
      },
    );
    this.skillId = obj.skillId || '';
    this.planState = obj.planState || '';
    this.createdDate = obj.createdDate || '';
    this.notAnswered = obj.notAnswered || false;
    this.isAdherent = obj.isAdherent || false;
  }

  get isNotApplicable(): boolean {
    return this.response.value === -1 || this.expected === null;
  }

  get isAdherentOnLive(): boolean {
    return this.response.value !== null
      && this.response.value !== -1
      && this.expected.value !== null
      && this.response.value >= this.expected.value;
  }

  get createdDateFormatted(): string {
    if (!this.createdDate) {
      return '';
    }
    return moment(this.createdDate).format('DD/MM/YYYY HH:mm');
  }

  get responseTextByType(): string {
    if (this.response.value === null || this.response.value === undefined) return 'Não respondido';
    if (this.response.value === -1) return 'Não se aplica';
    if (this.type.isBoolean) {
      return this.response.value === this.expected.value ? 'Atende o esperado' : 'Não Atende o esperado';
    }
    return this.response.text;
  }

  get expectedTextByType(): string {
    if (!this.expected) return 'Não definido';
    if (this.type.isBoolean) {
      return this.expected.value === 1 ? 'Conhecimento esperado' : 'Conhecimento não esperado';
    }
    return this.expected.text;
  }
}

export interface AssessmentItemSkillType {
  description: string;
  isBoolean: boolean;
  color: string;
  value: string;
}
